/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://hobdsgqboffajfel4f6thdjd7i.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-66l26flelrdtrdysujgsd2qiti",
    "aws_cloud_logic_custom": [
        {
            "name": "offerings",
            "endpoint": "https://x7epkgq4p9.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        },
        {
            "name": "onboarding",
            "endpoint": "https://nchsv5suve.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:b926f7ec-8baf-4f36-a1b9-3b3693d9c9f1",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_iSR9seFpw",
    "aws_user_pools_web_client_id": "48lfelk94vqhn9u6ckk7k23b3l",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dunkirk151012-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
